import React from 'react';
import { Project } from '../types';

type Props = {
  project: Project;
  safeProgress: number;
};

export default function OverviewSection({ project, safeProgress }: Props) {
  return (
    <div className="space-y-8">
      <div>
        <h3 className="text-lg font-semibold text-gray-900 mb-4">Progresso do Projeto</h3>
        <div className="w-full bg-gray-200 rounded-full h-4">
          <div className="bg-indigo-600 h-4 rounded-full text-center text-white text-xs leading-4" style={{ width: `${safeProgress}%` }}>
            {safeProgress}%
          </div>
        </div>
      </div>
      <div>
        <h3 className="text-lg font-semibold text-gray-900 mb-4">Cronograma</h3>
        <div className="bg-gray-50 p-4 rounded-lg">
          <div className="flex justify-between items-center mb-2">
            <span className="text-sm text-gray-600">Data de Início</span>
            <span className="font-medium">{project.start_date ? new Date(project.start_date).toLocaleDateString('pt-BR') : 'N/A'}</span>
          </div>
          <div className="flex justify-between items-center">
            <span className="text-sm text-gray-600">Data de Fim</span>
            <span className="font-medium">{project.end_date ? new Date(project.end_date).toLocaleDateString('pt-BR') : 'N/A'}</span>
          </div>
        </div>
      </div>
    </div>
  );
}